module.exports = __webpack_public_path__ + "img/category-popular-hover.8d2b7a41.png";